exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:480px){h1[data-v-342435ef]{font-size:1.5em!important;word-break:break-word!important}}", ""]);

// exports
